import apiServices from 'api_services/request-handler';
import { requestHandler } from 'utils/functions';
import { AppDispatch } from '../store';
import { setFormsLoading, setLabels } from '../slices/forms-slice';

export const getLabels = () => {
    return async (dispatch: AppDispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.getLabels,
                setLoading: setFormsLoading,
                setData: setLabels,
            }),
        );
    };
};

export const updateLabels = (data: any, onDone: any) => {
    return async (dispatch: AppDispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.updateLabels,
                setLoading: setFormsLoading,
                param_data: data,
                onDone
            }),
        );
    };
};